<template>
  <Modal :open="open" @close="$emit('close')">
    <h1 class="text-center font-extrabold text-xl">Clôturer la réclamation {{ complaint.friendlyId }}</h1>

    <FormField
      id="response_date"
      label="Date de réponse"
      name="response_date"
      placeholder="Date de réponse"
      v-model="responseDate"
      type="date"
      :required="true"
    />

    <Selector
      class="mt-3"
      id="response_nature"
      name="response_nature"
      label="Nature de la réponse"
      :required="true"
      v-model="responseNature"
      :options="responseNatureOptions"
    />

    <FormField
      class="mt-3"
      id="resolution_notes"
      label="Solution apportée / infos complémentaires"
      name="resolution_notes"
      required
      v-model="resolutionNotes"
    />

    <FormField
      class="mt-3"
      id="reimbursed_amount"
      label="Montant remboursé"
      name="reimbursed_amount"
      trailing-add-ons="€"
      type="number"
      v-model="reimbursedAmount"
    />

    <div class="mt-3 flex justify-end">
      <GenericButton @click="closeComplaint">Clôturer</GenericButton>
    </div>
  </Modal>
</template>

<script>
import { FormField, GenericButton, Modal, Selector } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { GenericButton, FormField, Selector, Modal },
  props: {
    open: {
      required: true,
      type: Boolean,
    },
    complaint: {
      required: true,
      type: Object,
    },
  },

  data: () => {
    return {
      responseNature: null,
      resolutionNotes: null,
      reimbursedAmount: null,
    };
  },

  mounted() {
    this.initiateData();
  },

  emits: ["close", "updated"],

  watch: {
    open(newValue) {
      if (newValue) {
        this.initiateData();
      }
    },
  },

  computed: {
    ...mapGetters("complaints", ["responseNatures"]),

    responseNatureOptions() {
      return this.responseNatures().map((nature) => ({
        value: nature,
        label: this.$t(`complaints.response_nature.${nature}`),
      }));
    },
  },

  methods: {
    ...mapActions("complaints", ["update"]),
    ...mapActions("notifications", ["notify"]),

    initiateData() {
      this.responseNature = this.complaint?.responseNature;
      this.resolutionNotes = this.complaint?.resolutionNotes;
      this.reimbursedAmount = this.complaint?.reimbursedAmount;
      this.responseDate = new Date().toISOString().split("T")[0];
    },

    async closeComplaint() {
      const response = await this.update({
        id: this.complaint.id,
        data: {
          status: "closed",
          responseDate: this.responseDate,
          responseNature: this.responseNature,
          resolutionNotes: this.resolutionNotes,
          reimbursedAmount: this.reimbursedAmount,
        },
      });

      if (response?.success) {
        this.notify({
          category: "simple",
          type: "success",
          title: "La réclamation a été clôturée.",
        });

        this.$emit("close");
        this.$emit("updated");
      }
    },
  },
};
</script>
